import React, { Component } from 'react';

class TimerHistory extends Component {
  render() {
    return <div />;
  }
}

export default TimerHistory;
